import { createSlice } from '@reduxjs/toolkit';

import { handleRequestThunk } from '../../handleRequestThunk';
import { getCarCharacteristic } from './carThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCarKey } from '../../sell/sellKeys';
const SLICE_NAME = 'carCharacteristic';

export const carCharacteristicSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCarCharacteristic(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCarCharacteristic });
        builder.addCase(clearCarKey, () => commonInitialState);
    },
});

export const { clearCarCharacteristic } = carCharacteristicSlice.actions;

export const characteristic = carCharacteristicSlice.reducer;
